import styled from "styled-components";
import mico from "../images/facebook-messenger.svg";

const MLink = styled.a`
position: fixed;
bottom: 20px;
left: 20px;
  text-decoration: none;
  color: inherit;
  font-weight: bold;

  img {
    margin-left: 8px;
  }
`;

export const MessengerLink = () => {
  return (
    <>
      <MLink href="https://m.me/100048795611189" target="_blank" rel="noopener">
        <img
          src={mico}
          alt="Messenger"
          style={{ width: "60px", height: "60px", verticalAlign: "middle" }}
        ></img>
      </MLink>
    </>
  );
};
